export const KEY_PATTERN = /^[A-Z][A-Z0-9_]{2,59}$/;
export const PRODUCT_NUMBER_PATTERN = /^[0-9]{2}-[0-9]{4}(?:-[0-9]{1,2})?$/;
export const MODULE_ID_PATTERN = /^[0-9]{1,10}$/;
export const GROUP_PATTERN = /^[A-Za-z0-9_]{1,30}$/;
export const MIN_REASON = 10;

/** "Wilderness First Aid" + "2026" -> WILDERNESS_FIRST_AID_2026 (a starting point the admin can edit before creating). */
export function suggestKey(name, edition) {
  const words = `${name || ""} ${edition || ""}`.toUpperCase().replace(/[^A-Z0-9]+/g, "_").replace(/^[^A-Z]+/, "").replace(/_+$/, "");
  return words.slice(0, 60);
}

export const serverMessage = (error, fallback) => error?.response?.data?.message || fallback;
